"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notes = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Sub_1 = require("../../../../../Page/Title/Sub");
require("./index.scss");
const className = 'flight-list-info-notes';
const Notes = (props) => {
    const { flight } = props;
    if (!flight)
        return null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'document', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/FlightListPage:Notes', defaultMessage: 'Notes' }) }),
        react_1.default.createElement("div", { className: `${className}__comment` }, flight.comment
            ? flight.comment.split('\n').map((item, key) => {
                return react_1.default.createElement(react_1.default.Fragment, { key: key },
                    item,
                    react_1.default.createElement("br", null));
            })
            : '')));
};
exports.Notes = Notes;
//# sourceMappingURL=index.js.map